import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import OrderTable from "../../components/Order"

const Orders = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Orders | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <OrderTable />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Orders
